var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "b-modal",
        {
          attrs: {
            id: _vm.MODAL_ID,
            title: "Batch Translate Images",
            size: "xl",
            "hide-footer": "",
            "no-close-on-backdrop": "",
          },
          on: { show: _vm.onModalOpen, hide: _vm.onModalHide },
        },
        [
          _c(
            "div",
            { staticClass: "position-relative modal-content-wrapper" },
            [
              _vm.currentStep === 1
                ? _c("div", [
                    _c(
                      "div",
                      {
                        staticClass:
                          "d-flex justify-content-between align-items-center mb-3",
                      },
                      [
                        _c("label", { staticClass: "mb-0 font-weight-bold" }, [
                          _vm._v("Select Templates to Translate"),
                        ]),
                        _vm._v(" "),
                        _c("div", [
                          _c(
                            "button",
                            {
                              staticClass:
                                "btn btn-sm btn-outline-secondary mr-1",
                              on: { click: _vm.selectAllTemplates },
                            },
                            [_vm._v("\n              Select All\n            ")]
                          ),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-sm btn-outline-secondary",
                              on: { click: _vm.deselectAllTemplates },
                            },
                            [
                              _vm._v(
                                "\n              Deselect All\n            "
                              ),
                            ]
                          ),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    _vm.allTemplates.length === 0
                      ? _c(
                          "div",
                          { staticClass: "text-muted text-center py-4" },
                          [
                            _vm._v(
                              "\n          No templates available.\n        "
                            ),
                          ]
                        )
                      : _c(
                          "div",
                          { staticClass: "template-selection-list" },
                          _vm._l(_vm.allTemplates, function (tmpl) {
                            return _c(
                              "div",
                              {
                                key: tmpl.instanceId,
                                staticClass: "template-selection-item",
                                class: {
                                  selected: _vm.selectedTemplateIds.includes(
                                    tmpl.instanceId
                                  ),
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.toggleTemplate(tmpl.instanceId)
                                  },
                                },
                              },
                              [
                                _c("b-form-checkbox", {
                                  staticClass: "mr-2",
                                  attrs: {
                                    checked: _vm.selectedTemplateIds.includes(
                                      tmpl.instanceId
                                    ),
                                  },
                                  on: {
                                    change: function ($event) {
                                      return _vm.toggleTemplate(tmpl.instanceId)
                                    },
                                  },
                                  nativeOn: {
                                    click: function ($event) {
                                      $event.stopPropagation()
                                    },
                                  },
                                }),
                                _vm._v(" "),
                                tmpl.canvasThumbnail
                                  ? _c(
                                      "div",
                                      { staticClass: "template-thumb mr-2" },
                                      [
                                        _c("img", {
                                          attrs: {
                                            src: tmpl.canvasThumbnail,
                                            alt: "",
                                          },
                                        }),
                                      ]
                                    )
                                  : _c("div", {
                                      staticClass:
                                        "template-thumb-placeholder mr-2",
                                    }),
                                _vm._v(" "),
                                _c("span", { staticClass: "template-name" }, [
                                  _vm._v(
                                    _vm._s(
                                      tmpl.name || `Template ${tmpl.instanceId}`
                                    )
                                  ),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  { staticClass: "ml-auto text-muted small" },
                                  [
                                    _vm._v(
                                      _vm._s(tmpl.imageCount) + " image(s)"
                                    ),
                                  ]
                                ),
                              ],
                              1
                            )
                          }),
                          0
                        ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "mt-3 d-flex justify-content-end" },
                      [
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-primary",
                            attrs: {
                              disabled: _vm.selectedTemplateIds.length === 0,
                            },
                            on: { click: _vm.goToStep2 },
                          },
                          [
                            _vm._v(
                              "\n            Next (" +
                                _vm._s(_vm.selectedTemplateIds.length) +
                                " selected)\n          "
                            ),
                          ]
                        ),
                      ]
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.currentStep === 2
                ? _c("div", [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-sm btn-outline-secondary mb-3",
                        on: {
                          click: function ($event) {
                            _vm.currentStep = 1
                          },
                        },
                      },
                      [
                        _c("i", { staticClass: "bi bi-arrow-left mr-1" }),
                        _vm._v(" Back\n        "),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "mb-3" },
                      [
                        _c("label", { staticClass: "font-weight-bold" }, [
                          _vm._v("Image Selection per Template"),
                        ]),
                        _vm._v(" "),
                        _vm._l(_vm.selectedTemplates, function (tmpl) {
                          return _c(
                            "div",
                            {
                              key: tmpl.instanceId,
                              staticClass:
                                "template-image-config mb-2 p-2 border rounded",
                            },
                            [
                              _c("div", [
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "font-weight-bold d-block mb-2",
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        tmpl.name ||
                                          `Template ${tmpl.instanceId}`
                                      )
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "image-checkbox-list" },
                                  _vm._l(tmpl.imageOptions, function (option) {
                                    return _c(
                                      "b-form-checkbox",
                                      {
                                        key: option.value,
                                        staticClass: "image-checkbox-item",
                                        attrs: {
                                          checked: _vm.isImageSelected(
                                            tmpl.instanceId,
                                            option.value
                                          ),
                                        },
                                        on: {
                                          change: function ($event) {
                                            return _vm.toggleImageSelection(
                                              tmpl.instanceId,
                                              option.value,
                                              $event
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "d-flex align-items-center",
                                          },
                                          [
                                            option.thumbnail
                                              ? _c("img", {
                                                  staticClass:
                                                    "image-thumbnail mr-2",
                                                  attrs: {
                                                    src: option.thumbnail,
                                                    alt: "",
                                                  },
                                                })
                                              : _c("span", {
                                                  staticClass:
                                                    "image-thumbnail-placeholder mr-2",
                                                }),
                                            _vm._v(" "),
                                            _c("span", [
                                              _vm._v(_vm._s(option.text)),
                                            ]),
                                          ]
                                        ),
                                      ]
                                    )
                                  }),
                                  1
                                ),
                              ]),
                            ]
                          )
                        }),
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "form-group" },
                      [
                        _c("label", { staticClass: "font-weight-bold" }, [
                          _vm._v("Select Languages"),
                        ]),
                        _vm._v(" "),
                        _c("Multiselect", {
                          staticClass: "multiselect-language",
                          attrs: {
                            options: _vm.availableLanguages,
                            multiple: true,
                            "close-on-select": false,
                            taggable: false,
                            placeholder: "Select language(s)...",
                          },
                          model: {
                            value: _vm.selectedTargetLanguages,
                            callback: function ($$v) {
                              _vm.selectedTargetLanguages = $$v
                            },
                            expression: "selectedTargetLanguages",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "form-group" },
                      [
                        _c(
                          "b-form-checkbox",
                          {
                            model: {
                              value: _vm.autoDetectTextBlocks,
                              callback: function ($$v) {
                                _vm.autoDetectTextBlocks = $$v
                              },
                              expression: "autoDetectTextBlocks",
                            },
                          },
                          [
                            _vm._v(
                              "\n            Auto-detect text blocks (recommended)\n          "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "d-flex justify-content-end" }, [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-primary",
                          attrs: {
                            disabled: !_vm.canTranslate || _vm.isTranslating,
                          },
                          on: { click: _vm.handleBatchTranslate },
                        },
                        [
                          _vm.isTranslating
                            ? _c("span", {
                                staticClass:
                                  "spinner-border spinner-border-sm mr-1",
                                attrs: {
                                  role: "status",
                                  "aria-hidden": "true",
                                },
                              })
                            : _vm._e(),
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                _vm.isTranslating
                                  ? "Translating..."
                                  : "Translate"
                              ) +
                              "\n          "
                          ),
                        ]
                      ),
                    ]),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.currentStep === 3
                ? _c("div", [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-sm btn-outline-secondary mb-3",
                        attrs: { disabled: _vm.isTranslating },
                        on: {
                          click: function ($event) {
                            _vm.currentStep = 2
                          },
                        },
                      },
                      [
                        _c("i", { staticClass: "bi bi-arrow-left mr-1" }),
                        _vm._v(" Back\n        "),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "results-container" },
                      _vm._l(
                        _vm.translationResults,
                        function (tmpl, resultIndex) {
                          return _c(
                            "div",
                            {
                              key: resultIndex,
                              staticClass: "result-template-row mb-4",
                            },
                            [
                              _c(
                                "h6",
                                { staticClass: "font-weight-bold mb-2" },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        tmpl.name ||
                                          `Template ${tmpl.instanceId}`
                                      ) +
                                      "\n            "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "translated-images-grid" },
                                _vm._l(
                                  tmpl.languages,
                                  function (item, langIdx) {
                                    return _c(
                                      "div",
                                      {
                                        key: langIdx,
                                        staticClass: "translated-image-item",
                                      },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "translated-image-label",
                                          },
                                          [_vm._v(_vm._s(item.language))]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "image-preview-wrapper position-relative",
                                          },
                                          [
                                            item.isLoading
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "d-flex flex-column justify-content-center align-items-center bg-light",
                                                    staticStyle: {
                                                      "min-height": "150px",
                                                      width: "100%",
                                                      "border-radius": "4px",
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "spinner-border text-primary",
                                                        attrs: {
                                                          role: "status",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "sr-only",
                                                          },
                                                          [_vm._v("Loading...")]
                                                        ),
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "mt-2 text-muted small",
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                      Translating...\n                    "
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                )
                                              : item.error
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "d-flex flex-column justify-content-center align-items-center bg-light text-danger",
                                                    staticStyle: {
                                                      "min-height": "150px",
                                                      width: "100%",
                                                      "border-radius": "4px",
                                                    },
                                                  },
                                                  [
                                                    _c("i", {
                                                      staticClass:
                                                        "bi bi-exclamation-triangle mb-2",
                                                      staticStyle: {
                                                        "font-size": "1.5rem",
                                                      },
                                                    }),
                                                    _vm._v(" "),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "mb-2 small",
                                                      },
                                                      [_vm._v("Failed")]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "button",
                                                      {
                                                        staticClass:
                                                          "btn btn-sm btn-outline-danger",
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            $event.stopPropagation()
                                                            return _vm.retryTranslation(
                                                              resultIndex,
                                                              langIdx
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [
                                                        _c("i", {
                                                          staticClass:
                                                            "bi bi-arrow-clockwise mr-1",
                                                        }),
                                                        _vm._v(
                                                          " Retry\n                    "
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                )
                                              : item.url
                                              ? [
                                                  _c("img", {
                                                    staticClass:
                                                      "img img-fluid modal-preview-image",
                                                    attrs: { src: item.url },
                                                  }),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "image-actions-container",
                                                    },
                                                    [
                                                      _c(
                                                        "button",
                                                        {
                                                          staticClass:
                                                            "retry-btn",
                                                          attrs: {
                                                            title:
                                                              "Retry translation",
                                                          },
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              $event.stopPropagation()
                                                              return _vm.retryTranslation(
                                                                resultIndex,
                                                                langIdx
                                                              )
                                                            },
                                                          },
                                                        },
                                                        [
                                                          _c("i", {
                                                            staticClass:
                                                              "bi bi-arrow-clockwise",
                                                          }),
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "button",
                                                        {
                                                          staticClass:
                                                            "download-btn",
                                                          attrs: {
                                                            title:
                                                              "Download image",
                                                          },
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              $event.stopPropagation()
                                                              return _vm.downloadImage(
                                                                item.url,
                                                                `${tmpl.name}-${item.language}`
                                                              )
                                                            },
                                                          },
                                                        },
                                                        [
                                                          _c("i", {
                                                            staticClass:
                                                              "bi bi-download",
                                                          }),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              : _vm._e(),
                                          ],
                                          2
                                        ),
                                      ]
                                    )
                                  }
                                ),
                                0
                              ),
                            ]
                          )
                        }
                      ),
                      0
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "mt-3 d-flex justify-content-between" },
                      [
                        _c(
                          "b-dropdown",
                          {
                            attrs: {
                              text: "Add all to new templates",
                              variant: "primary",
                              disabled:
                                _vm.isCreatingTemplates ||
                                !_vm.hasAnySuccessfulTranslation,
                            },
                          },
                          [
                            _c(
                              "b-dropdown-item",
                              {
                                on: {
                                  click: function ($event) {
                                    return _vm.handleAddAllToNewTemplates(
                                      "original"
                                    )
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  "\n              Original size\n            "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c("b-dropdown-divider"),
                            _vm._v(" "),
                            _c(
                              "b-dropdown-item",
                              {
                                on: {
                                  click: function ($event) {
                                    return _vm.handleAddAllToNewTemplates(
                                      1500,
                                      1500
                                    )
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  "\n              1500x1500\n            "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "b-dropdown-item",
                              {
                                on: {
                                  click: function ($event) {
                                    return _vm.handleAddAllToNewTemplates(
                                      2000,
                                      2000
                                    )
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  "\n              2000x2000\n            "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "b-dropdown-item",
                              {
                                on: {
                                  click: function ($event) {
                                    return _vm.handleAddAllToNewTemplates(
                                      2500,
                                      2500
                                    )
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  "\n              2500x2500\n            "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "b-dropdown-item",
                              {
                                on: {
                                  click: function ($event) {
                                    return _vm.handleAddAllToNewTemplates(
                                      3000,
                                      3000
                                    )
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  "\n              3000x3000\n            "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c("b-dropdown-divider"),
                            _vm._v(" "),
                            _c(
                              "b-dropdown-item",
                              {
                                on: {
                                  click: function ($event) {
                                    return _vm.handleAddAllToNewTemplates(
                                      "custom"
                                    )
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  "\n              Custom...\n            "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-outline-primary",
                            attrs: {
                              disabled: !_vm.hasAnySuccessfulTranslation,
                            },
                            on: { click: _vm.downloadAll },
                          },
                          [
                            _c("i", { staticClass: "bi bi-download mr-1" }),
                            _vm._v(" Download All\n          "),
                          ]
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.isCreatingTemplates
                      ? _c("div", { staticClass: "mt-2 text-center" }, [
                          _c("span", {
                            staticClass:
                              "spinner-border spinner-border-sm mr-1",
                            attrs: { role: "status" },
                          }),
                          _vm._v(
                            "\n          Creating templates... " +
                              _vm._s(_vm.templatesCreatedCount) +
                              "/" +
                              _vm._s(_vm.totalTemplatesToCreate) +
                              "\n        "
                          ),
                        ])
                      : _vm._e(),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.isDetectingTextBlocks
                ? _c("div", { staticClass: "loading-overlay" }, [
                    _c(
                      "div",
                      {
                        staticClass: "spinner-border text-primary",
                        attrs: { role: "status" },
                      },
                      [
                        _c("span", { staticClass: "sr-only" }, [
                          _vm._v("Loading..."),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "mt-2 font-weight-bold" }, [
                      _vm._v(
                        "\n          Detecting text blocks... (" +
                          _vm._s(_vm.textBlocksDetectedCount) +
                          "/" +
                          _vm._s(_vm.textBlocksTotal) +
                          ")\n        "
                      ),
                    ]),
                  ])
                : _vm._e(),
            ]
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }